const Splash = (function () {
  const $splash = $(".js-splash");
  const $closeSplashButton = $(".js-close-splash");

  function init() {
    $(function () {
      const $splashShowing = $(".js-splash-showing");
      if ($splashShowing.length > 0) {
        $splash.removeClass("splash--hidden");
        initTabHandlers();
        initCloseWithEscape();
        initCloseButton();
        $closeSplashButton.focus();
      }
    });
  }

  function initCloseWithEscape() {
    $(document).on("keydown.splash", function (e) {
      if (e.key === "Escape") {
        closeSplash();
      }
    });
  }

  function initCloseButton() {
    $closeSplashButton.on("click", function () {
      closeSplash();
    });
  }

  function initTabHandlers() {
    const $splashRightLink = $(".js-splash-right-link");
    $splashRightLink.on("keydown", function (e) {
      if (e.key === "Tab") {
        e.preventDefault();
        $closeSplashButton.focus();
      }
    });

    $closeSplashButton.on("keydown", function (e) {
      if (e.shiftKey && e.key === "Tab") {
        e.preventDefault();
        $splashRightLink.focus();
      }
    });
  }

  function closeSplash() {
    $splash.addClass("splash--hidden");
    $(document).off("keydown.splash");
  }

  return {
    init,
  };
})();

export default Splash;
